/* Footer-only: keep /en-de on links Shopify normalizes to /pages/... */
(function () {
  try {
    var prefix = '/en-de';
    if (location.pathname.indexOf(prefix + '/') !== 0 && location.pathname !== prefix) return;
    document.querySelectorAll('.footer-zenbox a[href^="/pages/"], .footer-zenbox a[href^="/blogs/"], .footer-zenbox a[href^="/products/"]').forEach(function (a) {
      var h = a.getAttribute('href');
      if (h && h.indexOf(prefix + '/') !== 0) a.setAttribute('href', prefix + h);
    });
  } catch (e) {}
})();
